import React, { useEffect, useState } from 'react';

import firebase from 'firebase/app';
import 'firebase/firestore';
import pluralize from 'pluralize';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

import { Upload } from './types'
import Link from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import UploadDialog from './UploadDialog';

const useStyles = makeStyles({
  paper: {
    width: '50%',
    margin: 'auto',
  },
});

function useUploadList() {
  const [files, setFiles] = useState(new Array<Upload>());

  useEffect(() => {
    const db = firebase.firestore();
    const unsub = db
      .collection('uploads')
      .onSnapshot(snapshot => {
        setFiles(snapshot.docs.map(doc => doc.data() as Upload)
          .sort((a, b) => b.folder.localeCompare(a.folder))
        )
      })
    return () => {
      unsub();
    };
  }, []);

  return files;
}

export default function UploadList() {
  const classes = useStyles();
  const files = useUploadList();

  const [editFile, setEditFile] = useState<Upload>();
  const [deleteFile, setDeleteFile] = useState<Upload>();
  const closeEditFile = (open: boolean) => setEditFile(undefined);
  const handleDelete = () => {
    const db = firebase.firestore();
    db.collection('uploads')
      .doc(deleteFile!.id)
      .delete();

    const storage = firebase.storage();
    const location = storage.ref(`/uploads/${deleteFile!.id}/${deleteFile!.filename}`);
    location.delete();

    setDeleteFile(undefined);
  }

  return (
    <TableContainer className={classes.paper} component={Paper}>
      <Table>
        <TableBody>
          {files.map(file => (
            <TableRow key={file.id}>
              <TableCell>
                <Link href={`/download/${file.id}`}>{file.folder}</Link>
              </TableCell>
              <TableCell>{`${file.downloadCount} ${pluralize("download", file.downloadCount)}`}</TableCell>
              <TableCell align="right">
                <IconButton onClick={() => setEditFile(file)}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => setDeleteFile(file)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <UploadDialog open={Boolean(editFile)} setOpen={closeEditFile} edit={editFile} />
      <Dialog open={Boolean(deleteFile)} onClose={() => setDeleteFile(undefined)}>
        <DialogTitle>Are you sure you want to permanently delete the file?</DialogTitle>
        <DialogActions>
          <Button onClick={() => setDeleteFile(undefined)} autoFocus>
            Cancel
          </Button>
          <Button onClick={handleDelete} color="primary" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </TableContainer >
  );
}